import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const authUserBalance = createSlice({
  name: "userbalance",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    BalSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },

    updateUserBalance: (state, action) => {
      if (state.data) {
        state.data.balance = action.payload;
      }
    },
  },
});

// Actions
export const { requestStart, BalSuccess, requestFailure, updateUserBalance } =
  authUserBalance.actions;

export const GetUserBlance = (user) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const GetBalance = await axios.get(`/private/bal/${user?.id}`);
    if (GetBalance?.data) {
      dispatch(BalSuccess(GetBalance?.data));
    }
  } catch (err) {
    // Handle errors
    toast.error(err?.response?.data?.message || err.message || " failed!");
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export default authUserBalance.reducer;
